import { useState } from "react";
import { MobileMenuIcon } from "../style";
import { AreaButtonCurriculo, ButtonCurriculo } from "./style";

function ButtonsCurriculo() {
  const [isMobile, setIsMobile] = useState(false);
  return (
    <>
      <AreaButtonCurriculo className={isMobile ? "False" : "True"}>
        <a
          target="blank"
          href="https://docs.google.com/document/d/e/2PACX-1vRsruPUC9PKY1zO9AQnz4hbT0QhBic6S6OuvpRIyYTM41CBnPvgqoKxfAALCh45LO59vSScask2UcTV/pub?embedded=true"
        >
          <ButtonCurriculo>
            <spam>MEU CURRICULO</spam>
          </ButtonCurriculo>
        </a>
      </AreaButtonCurriculo>
      <MobileMenuIcon onClick={() => setIsMobile(isMobile)} />
    </>
  );
}
export default ButtonsCurriculo;
